export default __webpack_public_path__ + "static/media/Logo_Banco_Desio.a6b30812.png";